import { withLDProvider } from 'launchdarkly-react-client-sdk';
import { HelmetProvider } from 'react-helmet-async';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { UniversalNavigationContextProvider } from '@fff-web/fff-global-nav';
import { FontAwesome } from '@fff-web/fff-ui-shared';
import GiftCardHomePage from './pages/Gift';
import GiftCardRedemption from './pages/GiftCardRedemption';
import GiftConfirmation from './pages/GiftConfirmation';
import NotFoundError from './pages/NotFoundError';
import { addPathPrefix } from './utils/helpers';
import './App.css';

/**
 * Main App component
 * @returns {import('react').ReactNode} - React node
 */
function App() {
  return (
    <HelmetProvider>
      <UniversalNavigationContextProvider>
        <FontAwesome />
        <Router>
          <Routes>
            {addPathPrefix('/gift').map((path) => (
              <Route key={path} path={path} element={<GiftCardHomePage />} />
            ))}
            {addPathPrefix('/gift-card-confirm').map((path) => (
              <Route key={path} path={path} element={<GiftConfirmation />} />
            ))}
            {addPathPrefix('/redeem-gift').map((path) => (
              <Route key={path} path={path} element={<GiftCardRedemption />} />
            ))}
            <Route path="*" element={<NotFoundError />} />
          </Routes>
        </Router>
      </UniversalNavigationContextProvider>
    </HelmetProvider>
  );
}

export default withLDProvider({
  clientSideID: process.env.REACT_APP_LD_CLIENT_ID,
  options: { bootstrap: 'localStorage' },
  context: {
    kind: 'user',
    key: 'anonymous',
  },
})(App);
